<template>
    <main-content with_go_back_bar>
        <kt-panel v-if="!activeGateways().has_gateway">
            <kt-panel-body>
                <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                    {{ $t('message.no_gateway') }}
                    <router-link
                        class="btn btn-brand d-block w-25 text-center align-content-center mx-auto mt-3"
                        to="/gateways"> {{ $t('btn.create_gateway') }}</router-link>
                </p>
            </kt-panel-body>
        </kt-panel>
        <kt-panel v-else-if="!activeGateways().has_active_gateway">
            <kt-panel-body>
                <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                    {{ $t('message.no_active_gateway') }}
                </p>
            </kt-panel-body>
        </kt-panel>
        <money-request-form v-else
                            :submitSingleRequest="submitSingleRequest"
                            :submitGroupRequest="submitGroupRequest"
        >
        </money-request-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {gatewayTypes} from "@/constants/gatewayTypes";
import Form from './components/form'
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {mapGetters} from "vuex";
import {KTApp} from "@/plugins/core/app";
import {moneyRequestService} from "@/common/api.service";

export default {
    components: {
        'main-content': mainContent,
        'money-request-form': Form
    },
    computed: {
        ...mapGetters('gateway', [
            'gateways'
        ]),
    },
    methods: {
        submitSingleRequest(e, query) {
            let form = $('#single-request-form')
            let btn = $('#form-btn')

            form.validate( {
                rules: {
                    full_name: {
                        required: true
                    },
                    amount: {
                        required: true,
                    },
                    phone: {
                        required: true,
                        minlength: 11,
                        digits: true
                    },
                    description: {
                        maxlength: 200,
                    }
                }
            })

            if (!form.valid())
                return;

            KTApp.progress(btn)

            let descrition = query.description;
            if(descrition == undefined || descrition == 'undefined') {
                descrition = '';
            }


            let params = {
                full_name: query.full_name,
                phone: query.phone,
                amount: query.amount,
                description: descrition
            }

            moneyRequestService.create(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        submitGroupRequest(e, query) {
            let form = $('#gregarious-request-form')
            let btn = $('#excel-form-btn')

            form.validate( {
                rules: {
                    file: {
                        required: true
                    }
                }
            })

            if (!form.valid())
                return;

            KTApp.progress(btn)

            let params = {
                file: query.file
            }

            moneyRequestService.create(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                // if(response.data) {
                //     form.validate().showErrors(response.data.data)
                // }
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        backToMoneyRequestsList() {
            this.$router.push('/money-request')
        },
        activeGateways() {
            var active_gateways = []

            if (this.gateways.length < 1) {
                active_gateways.has_gateway = false
                return active_gateways
            }

            active_gateways.has_gateway = true

            active_gateways.gates = []
            active_gateways.has_active_gateway = false
            var gateway
            for (gateway of this.gateways) {
                if ((gateway.status === 1 || gateway.status === '1') && gateway.gateway_type === gatewayTypes.PARDAKHTYARI) {
                    active_gateways.gates.push(gateway)
                    active_gateways.has_active_gateway = true
                }

            }

            return active_gateways
        },
    },
    mounted() {
        this.$store.dispatch('gateway/fetch')
        this.activeGateways()
    }
}
</script>
